export const environment = {
  production: false,
  baseUrl: {
    nflTeams: "https://voysgc9b80.execute-api.us-east-1.amazonaws.com/dev/nfl",
    teamVisits: "https://voysgc9b80.execute-api.us-east-1.amazonaws.com/dev/visits"
  }
};
